import { render, staticRenderFns } from "./TBAuthorization.vue?vue&type=template&id=79a5e974&scoped=true"
import script from "./TBAuthorization.vue?vue&type=script&lang=js"
export * from "./TBAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a5e974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a5e974')) {
      api.createRecord('79a5e974', component.options)
    } else {
      api.reload('79a5e974', component.options)
    }
    module.hot.accept("./TBAuthorization.vue?vue&type=template&id=79a5e974&scoped=true", function () {
      api.rerender('79a5e974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/TBAuthorization.vue"
export default component.exports